// export const myAction = ( state ) => {
// }

export const setTenants = (state, tenants) => {
  state.tenants = tenants
}

export const setCurrentTenant = (state, tenant) => {
  state.currentTenant = tenant
}

export const setLoading = (state, loading) => {
  state.loading = loading
}